module.exports = __webpack_public_path__ + "static/media/ATMA-SPHERE M-60 TUBE AMPLIFIER.dad2607b.png";